export default __webpack_public_path__ + "static/home-page-bg@2x-optimized-ee185d59be2f3c942f1413240cbc2f88.jpg";